module.exports = __webpack_public_path__ + "assets/headlight-white.1cc83c5c.svg";